var map = {
	"./65271357_p1_master1200.jpg": "LbYA",
	"./akebono_kantai_collection_drawn_by_pentagon_railgun_ky1206__sample-8973e534ce6041a1624714a51aa39d43.jpg": "LZY0",
	"./ee17bef4b7fd656a8dd61d6785396fe0.jpg": "mTjz",
	"./kasumi and kiyoshimo relaxing.jpg": "XVUw"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "GNxJ";